const translation = {
  'apply.seo.title': 'Learn to Teach English (TEFL) en Barcelona o Sevilla',
  'apply.seo.description': `Conviértete en el profesor de TEFL que deseas ser solicitando los cursos de TEFL divertidos, profesionales y asequibles de TEFL Iberia.`,

  'apply.sec1.title': `Completa el siguiente formulario de inscripción sin compromiso y te contactaremos en menos de 12 horas
  `,

  'apply.step1.title': `PASO 1`,
  'apply.step1.text': `Inscripción`,

  'apply.step2.title': `PASO 2`,
  'apply.step2.text': `Prueba de nivel`,

  'apply.step3.title': `PASO 3`,
  'apply.step3.text': `Entrevista`,

  'apply.step4.title': `PASO 4`,
  'apply.step4.text': `Reserva de plaza`,

  'apply.form.title': `El Curso`,
  'apply.form.subTitle1': `¿Qué curso quieres hacer?*`,
  'apply.form.course.option1': `Trinity CertTESOL presencial en Barcelona`,
  'apply.form.course.option2': `Trinity CertTESOL presencial en Sevilla`,
  'apply.form.course.option3': `Curso Docente Avanzado `,
  'apply.form.course.option4': `Curso Docente Avanzado  + Catalán`,
  'apply.form.course.option5': `No estoy seguro/a`,

  'apply.form.subTitle2': `Fecha de inicio*`,
  'apply.form.prefferedCourseDate': `Seleccione la fecha de su curso preferido`,
  'apply.form.date.option1': `3 de julio 2023`,
  'apply.form.date.option2': `31 de julio 2023`,
  'apply.form.date.option3': `4 de septiembre 2023`,

  'apply.form.subTitle3': `¿Quieres apuntarte a un curso de extensión para aplicar a una visa de estudiante?
  `,
  'apply.form.extension.option1': `Curso Docente Avanzado`,
  'apply.form.extension.option2': `Curso Docente Avanzado + Catalán`,
  'apply.form.extension.option3': `No estoy seguro/a`,

  'apply.form.title2': `Tu información de contacto`,
  'apply.form.about.firstName': `Nombre*`,
  'apply.form.about.lastName': ` Apellido* `,
  'apply.form.about.email': `Correo electrónico*`,
  'apply.form.about.phone': `Número de teléfono`,
  'apply.form.about.userLocation': `Tu ubicación actual*`,
  'apply.form.about.userLocation.placeholder': `e.j . Buenos Aires, Argentina`,
  'apply.form.about.nativeSpeaker': `¿Eres hablante nativo/a de inglés?*`,
  'apply.form.about.nativeSpeaker.yes': `Si`,
  'apply.form.about.nativeSpeaker.no': `No`,
  'apply.form.about.nationality': `Nacionalidad*`,
  'apply.form.about.nationality.placeholder': `Fecha de nacimiento*`,
  'apply.form.about.dateOfBirth': `Date of birth*`,
  'apply.form.about.dateOfBirth.dd': `DÍA`,
  'apply.form.about.dateOfBirth.mm': `MES`,
  'apply.form.about.dateOfBirth.yyyy': `AÑO`,

  'apply.form.subTitle4': `Servicios adicionales`,
  'apply.form.service.title': `¿Necesitas algún servicio adicional? Por favor, selecciona los servicios adicionales que necesites:`,
  'apply.form.service.accommodation': `Hospedaje`,
  'apply.form.service.airportPickUp': `Recogida en aeropuerto  `,
  'apply.form.service.nieTie': `Cita y asistencia para obtener tu TIE/NIE`,
  'apply.form.service.culturalActivities': `Actividades culturales`,
  'apply.form.service.promotionalCode': `Código promocional`,
  'apply.form.service.promotionalCode.placeholder': `Inserta el código`,
  'apply.form.service.comments': `Comentarios/preguntas`,
  'apply.form.service.comments.placeholder': `¿Tienes algún comentario o pregunta? Escríbelo aquí`,
  'apply.form.service.termsTitle': `Términos y condiciones*`,
  'apply.form.service.terms': `Estoy de acuerdo con los
  <a1>
  términos y condiciones
  </a1>
  y con la
  <a2>
  política de privacidad
  </a2> de TEFL Iberia.
  `,

  'apply.form.btn.submit': `Enviar  solicitud`,
};
export default translation;
